import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import ListingTable from "../../../listing/listing";

export const EventdayarrNotCreated = ({ eventdayarrNotCreatedListFetched }) => {
    const [eventdayarrNotCreatedList, setEventdayarrNotCreatedList] = useState([]);
    const [listFetchSuccess, setListFetchSuccess] = useState(false);
    const [loaderFlag, setloaderFlag] = useState(true);

    const eventdayarrNotCreatedListObj = {
        tableId: "eventdayarrNotCreatedLists",
        tableTitle: "Eventdayarr Not Created List",
        showReload: true,
        showFilter: true,
        api: {
            url: process.env.REACT_APP_API_URL,
            endPoint: "calendarapi/eventdayarr-not-created",
            // deleteSingleUserEndpoint: "api/delete-user",
            tableCountEndpoint: "calendarapi/eventdayarr-not-created",
        },

        reqBody: {
            "condition": {
                "limit": 5,
                "skip": 0
            },
            "sort": {
                "field": "_id",
                "type": "desc"
            },
            "searchcondition": {
            },
            "count": false
        },
        deleteSingleUserReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },
        deleteMultipleReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },

        //******************************** By Default Rows per page option will be available**************************//

        rowsPerPageOptions: [5, 10, 20, 30],
        sortFields: ["lastname", "email", "type"],
        paginationType: "stackPagination",
        enableRowActionLoader: true,
        customBtnHead: [
            // {
            //     id: "deleteMultiple",
            //     type: "delete_icon",
            //     title: "Delete",
            // },
            // {
            //     id: "editMultiple",
            //     type: "toggle_on_icon",
            //     title: "Status Change",
            // },
            // {
            //     id: "adduser",
            //     type: "add_icon",
            //     title: "ADD USER",
            //     className: "add_user_icon",
            //     default: true,
            // },
        ],
        buttons: [
        ],
        deleteModal: {
            modalClassName: "Delete Modal Deletemodal",
        },

        searchBarData: {
            heading: "Search Eventdayarr Not Created List",
            api: {
                url: process.env.REACT_APP_API_URL,
                endPoint: "calendarapi/eventdayarr-not-created",
                tableCountEndpoint: "calendarapi/eventdayarr-not-created",
                reqBody: {
                    // count:true,
                    // "source": "users",
                    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzYzNTZkNDFjZTE3MzAwMDhiOGFhYTUiLCJzZWNyZXQiOiJ6R3RpMnY1enYiLCJpYXQiOjE2Njc5Njg3MzV9.wzFi1CoHbv9QK5cUHbVgSL6LW8m6fR_BaILcT7OcHBQ",
                    condition: {
                        limit: 5,
                        skip: 0,
                    },
                    sort: {
                        type: "desc",
                        field: "_id",
                    },
                },
            },

            searchSettings: {
                datesearch: [
                    {
                        id: 0,
                        heading: "Search By Joining Date",
                        startdatelabel: "Start Date",
                        enddatelabel: "End Date",
                        className: "formGroup createdon_datetime countDiv__column--col4",
                        submit: "Search",
                        field: "createdon_datetime",
                    },
                ],
                selectsearch: [
                    {
                        id: 1,
                        label: "Search By Timezone",
                        field: "timezone",
                        type: "select",
                        values: ["-09:00|America/Anchorage", "-08:00|America/Los_Angeles", "-07:00|America/Phoenix", "-06:00|America/Chicago", "-05:00|America/New_York", "-10:00|Pacific/Honolulu", "+05:30|Asia/Kolkata"],
                        // value: "",
                    },


                ],
                textsearch: [
                    {
                        id: 2,
                        // heading: "Search By First Name",
                        label: "Search By Event Title ",
                        field: "event_title",
                        className: "formGroup event_title countDiv__column--col4",
                        value: "",
                    },
                    {
                        id: 3,
                        // heading: "Search By First Name",
                        label: "Search By description ",
                        field: "description",
                        className: "formGroup description countDiv__column--col4",
                        value: "",
                    },
                ],

            },
        },
    };

    var modifyTableHeaders =
        [
            { val: "summary", name: "Summary" },
            { val: "connected_gmail", name: "Connected Gmail" },
            { val: "user_email", name: "User Email" },
            { val: "organizer_email", name: "Organizer Email" },
            { val: "timespan", name: "Timespan" },
            { val: "start_date_time", name: "Start Date Time", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },
            { val: "end_date_time", name: "End Date Time", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },

        ];

    const getList = async () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(eventdayarrNotCreatedListObj.reqBody),
        };
        const response = await fetch(
            process.env.REACT_APP_API_URL + "calendarapi/eventdayarr-not-created",
            requestOptions
        );
        const respdata = await response.json();
        console.log("++++cv+++++++", respdata);
        if (respdata && respdata.status === "success") {
            setEventdayarrNotCreatedList([...respdata.results.res])
        }
        setloaderFlag(false);
        eventdayarrNotCreatedListFetched(true);
    }

    useEffect(() => {
        if (eventdayarrNotCreatedList && eventdayarrNotCreatedList.length === 0 && !listFetchSuccess) {
            setListFetchSuccess(true);
            getList()
        }

    }, [eventdayarrNotCreatedList]);

    return (
        <>
            {loaderFlag == true ? (
                <Box sx={{ width: "100%", mt: "10px" }}>
                    <app-progressbar />
                </Box>
            ) : (
                ""
            )}

            <div className="reactTableWrapper miscList">

                {!loaderFlag && eventdayarrNotCreatedList !== undefined ? (
                    <ListingTable
                        tableData={eventdayarrNotCreatedListObj}
                        dataset={eventdayarrNotCreatedList}
                        modifyHeaders={modifyTableHeaders}
                    />
                ) : ''}

            </div>
        </>
    )
}